import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { useState } from 'react';

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function TopImage(props: Props) {
  const [active, setActive] = useState(false)
  setTimeout(() => {
    setActive(true)
  }, 1500)
  return (
    <Box component={'section'} sx={(theme) => ({
      position: 'relative',
      width: '100%',
      height: 'calc(100vh - 100px)',
      backgroundPosition: 'center center',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(/assets/images/top.jpg)`,
    })}>
      <Box style={{ position: 'relative' }}>
        <Shuter />
        <Box sx={(theme) => ({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: 'calc(100vh - 100px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.palette.grey[50],
          zIndex: 1
        })}>
          <TopImageTitle variant="h1">
            <Box>
              <Box component={'span'} className={`underline primary ${active && 'active'}`}>
                <Box component={'span'} className={"primary"}>
                  W
                </Box>
                <Box component={'span'}>
                  ELCOME TO
                </Box>
              </Box>
            </Box>
            <Box sx={{ marginTop: '1rem', textAlign: 'right' }}>
              <Box component={'span'} className={`underline secondary ${active && 'active'}`}>
                <Box component={'span'} className={"secondary"}>
                  S
                </Box>
                <Box component={'span'}>
                  UPRIME !
                </Box>
              </Box>
            </Box>
          </TopImageTitle>
        </Box>
      </Box>
      <Box sx={(theme) => ({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 'calc(100vh - 100px)',
        backgroundColor: theme.palette.grey[900],
        opacity: '0.7',
      })} />
    </Box >
  );
}

/** タイトルコンポーネント */
function TopImageTitle(props: TypographyProps) {
  return (
    <Typography
      {...props}
      sx={(theme) => ({
        padding: '1rem',
        color: theme.palette.grey[50],
        fontSize: '2.5rem',
        fontWeight: 'bold',
        '.underline': {
          position: 'relative',
          '&.primary:after': {
            background: theme.palette.primary.main,
          },
          '&.secondary:after': {
            background: theme.palette.secondary.main,
          },
          '&:after': {
            position: 'absolute',
            left: 0,
            content: `''`,
            width: '100%',
            height: '0.2em',
            bottom: '-0.1em',
            transform: 'scale(0, 1)',
            transformOrigin: 'left top',
            transition: 'transform 0.5s'
          },
          '&.active': {
            '&::after': {
              transform: 'scale(1, 1)'
            }
          }
        },
        [theme.breakpoints.up('sm')]: {
          fontSize: '3rem',
          '.underline': {
            '&:after': {
              height: '0.5rem',
            }
          },
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '4rem',
          '.underline': {
            '&:after': {
              height: '0.75rem',
            }
          },
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: '5rem',
          '.underline': {
            '&:after': {
              height: '1rem',
            }
          },
        },
        'span .primary': {
          color: theme.palette.primary.main,
        },
        'span .secondary': {
          color: theme.palette.secondary.main,
        }
      })}>
      {props.children}
    </Typography>
  )
}

/** シャッターコンポーネント */
function Shuter(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={(theme) => ({
        position: 'absolute',
        height: 'calc(100vh - 100px)',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#212121',
        zIndex: 50,
        animation: 'byeShutter 2.0s forwards',
        '&::before': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          margin: 'auto',
          backgroundColor: '#fafafa',
          width: 0,
          height: 1,
          animation: 'shutterOpen 2.0s forwards'
        },
        '@keyframes byeShutter': {
          '70%': {
            opacity: 1
          },
          '100%': {
            opacity: 0,
            display: 'none',
            zIndex: -1,
          }
        },
        '@keyframes shutterOpen': {
          '0%': {
            width: 0,
            height: 5
          },
          '50%': {
            width: '100%',
            height: 5
          },
          '90%': {
            width: '100%',
            height: '100%'
          },
          '100%': {
            width: '100%',
            height: '100%'
          }
        }
      })}>
      {props.children}
    </Box >
  )
}